import {Component, EventEmitter, Input, Output, ViewEncapsulation} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {PlantDataService} from "../../services/plant-data/plant_data.service";
import {SeriesDataService} from "../../services/series_data.service";
import {ApiService} from "../../services/api/api.service";
import {EditFlowchartComponent} from "../edit_component";
import {ComponentConstantsTableService} from "../../tables/component-constants-table/component-constants-table.service";
import {BaseComponent} from "../../shared/base.component";
import {takeUntil} from "rxjs/operators";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {SharedModule} from "../../shared/modules/shared-module.module";
import {ComponentConstantTableComponent} from "../../components/component-constant-table.component";
import {SelectManySearchComponent} from "../../components/select-search/select-many-search.component";
import {SeriesComponentTableComponent} from "../../components/series-component-table.component";
import {ConstantSeriesDataComponent} from "../../components/constant_series_data.component";

@Component({
    selector: 'flowchart-equipment-form',
    templateUrl: 'flowchart-equipment-form.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
        SharedModule,
        SelectSearchComponentComponent,
        ComponentConstantTableComponent,
        SelectManySearchComponent,
        SeriesComponentTableComponent,
        ConstantSeriesDataComponent
    ],
    providers: [ComponentConstantsTableService]
})

export class FlowchartEquipmentFormComponent extends BaseComponent {

    @Input() flowchart: any;
    @Input() component: any;
    @Input() show_hints: boolean;
    @Input() dialog: boolean;

    @Output() save_event: EventEmitter<any> = new EventEmitter();
    @Output() close_event: EventEmitter<any> = new EventEmitter();

    efc: EditFlowchartComponent;
    hint: string;
    showing_hints: any;

    constructor(private plantData: PlantDataService,
                private seriesData: SeriesDataService,
                private api: ApiService,
                private http: HttpClient,
                private componentConstantTableService: ComponentConstantsTableService) {
        super();
    }

    ngOnInit(): void {
        this.efc = new EditFlowchartComponent(this.flowchart, this.component, this.plantData, this.seriesData, this.api,
            this.http, this.componentConstantTableService);
        this.efc.loadForm();
        this.efc.saveComplete.pipe(takeUntil(this.onDestroy)).subscribe((saved: boolean) => {
            this.save_event.emit(this.efc.component_view);
        });
    }

    save(): void {
        this.efc.save();
    }

    close(): void {
        this.close_event.emit();
    }
}
